import { transformComponent } from '../__builtins__/shared';
import { connect, mapProps, mapReadPretty } from '@formily/vue';
import { Rate as VanRate } from 'vant';
import { PreviewText } from '../preview-text';
var TransformVanRate = transformComponent(VanRate, {
    change: 'input',
});
export var Rate = connect(TransformVanRate, mapProps({ readOnly: 'readonly' }), mapReadPretty(PreviewText.Rate));
export default Rate;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/rate/index.js
// module id = null
// module chunks = 